import React from 'react';
import { Helmet } from 'react-helmet';
import useSiteMetadata from '../../hooks/site-metadata-hook';

function SEO(_ref) {
  var description = _ref.description,
      lang = _ref.lang,
      meta = _ref.meta,
      title = _ref.title,
      url = _ref.url;
  var metadata = useSiteMetadata();
  var metaTitle = lang === 'ja' ? metadata.titleJa : metadata.titleEn;
  var metaDescription = description || lang === 'ja' ? metadata.descJa : metadata.descEn;
  var metaAuthor = description || lang === 'ja' ? metadata.authorJa : metadata.authorEn;
  var canonical = url ? url : null;
  var baseMeta = [{
    name: "description",
    content: metaDescription
  }, {
    property: "og:title",
    content: title
  }, {
    property: "og:description",
    content: metaDescription
  }, {
    property: "og:type",
    content: "website"
  }, {
    name: "twitter:card",
    content: "summary"
  }, {
    name: "twitter:creator",
    content: metaAuthor
  }, {
    name: "twitter:title",
    content: title
  }, {
    name: "twitter:description",
    content: metaDescription
  }];
  return /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang: lang
    },
    title: title,
    titleTemplate: "%s | " + metaTitle,
    meta: meta ? baseMeta.concat(meta) : baseMeta,
    link: [// {
    //   rel: `canonical`,
    //   href: `/web/tweet-button`,
    // },
    canonical ? {
      rel: 'canonical',
      href: canonical
    } : {}] // script={[
    //   {
    //     type: `text/javascript`,
    //     async: true,
    //     src: `https://platform.twitter.com/widgets.js`,
    //   },
    // ]}

  });
}

export default SEO;